import React, { useEffect, useState } from "react";
import {
  listManagedDrawings,
  selectManagedDrawing,
  subscribeChartWidget,
  subscribeDrawingsChange,
  toggleDrawingLock,
  toggleDrawingVisible,
  openDrawingProperties,
  removeManagedDrawing,
} from "./chartToolBridge";

const ICONS = {
  series:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"><polyline points="3.2,16.8 8.2,10.4 12.1,13.2 17.2,6.2 20.8,9.4" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  gann:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"><line x1="5.1" y1="18.9" x2="18.9" y2="5.1" stroke="currentColor" stroke-width="2"/><g fill="#fff" stroke="currentColor" stroke-width="1.8"><circle cx="5.1" cy="18.9" r="2.4"/><circle cx="12" cy="12" r="2.4"/><circle cx="18.9" cy="5.1" r="2.4"/></g></svg>',
  gannFan:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"><g stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><line x1="5.2" y1="18.8" x2="19" y2="4.8"/><line x1="5.2" y1="18.8" x2="19.2" y2="10.2"/><line x1="5.2" y1="18.8" x2="19.2" y2="15.4"/></g></svg>',
  gannGrid:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"><rect x="4.4" y="4.4" width="15.2" height="15.2" stroke="currentColor" stroke-width="1.6"/><path d="M4.4 9.5h15.2M4.4 14.5h15.2M9.5 4.4v15.2M14.5 4.4v15.2" stroke="currentColor" stroke-width="1.6"/></svg>',
  fib:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"><g stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></g></svg>',
  channel:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"><g stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="7.6" y1="10.2" x2="16.6" y2="1.2"/><line x1="5.2" y1="18.6" x2="18.8" y2="5"/><line x1="7.4" y1="22.8" x2="16.4" y2="13.8"/></g></svg>',
  rectangle:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"><rect x="5" y="5" width="14" height="14" rx="1.6" stroke="currentColor" stroke-width="1.7"/></svg>',
  text:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M4.2 4.4h15.6v2.3H13.3V19.6h-2.6V6.7H4.2z"/></svg>',
  trend:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"><line x1="5.2" y1="18.6" x2="18.8" y2="5.4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/><g fill="#fff" stroke="currentColor" stroke-width="1.6"><circle cx="5.2" cy="18.6" r="2.2"/><circle cx="18.8" cy="5.4" r="2.2"/></g></svg>',
};

const ACTION_ICONS = {
  lock:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none"><rect x="6" y="11" width="12" height="9" rx="1.6" stroke="currentColor" stroke-width="1.8"/><path d="M8.4 11V8.2a3.6 3.6 0 0 1 7.2 0V11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  lockOpen:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none"><rect x="6" y="11" width="12" height="9" rx="1.6" stroke="currentColor" stroke-width="1.8"/><path d="M8.4 11V8.2a3.6 3.6 0 0 1 7.1-.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
  settings:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none"><g stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9.59 3.94c.09-.54.56-.94 1.11-.94h2.6c.55 0 1.02.4 1.11.94l.21 1.28c.07.37.32.69.65.87.07.04.15.08.22.13.32.19.72.25 1.07.12l1.22-.45c.5-.19 1.06.02 1.37.49l1.3 2.25c.26.45.15 1.04-.26 1.43l-1 .83c-.3.24-.44.61-.43.99v.25c0 .38.14.75.43.99l1 .83c.41.35.52.98.26 1.43l-1.3 2.25c-.31.47-.87.68-1.37.49l-1.22-.46c-.35-.13-.75-.07-1.07.13-.07.04-.15.08-.22.12-.33.19-.58.5-.65.87l-.21 1.28c-.09.54-.56.94-1.11.94h-2.6c-.55 0-1.02-.4-1.11-.94l-.21-1.28c-.07-.37-.32-.68-.65-.87a6.3 6.3 0 0 1-.22-.12c-.32-.2-.72-.26-1.07-.13l-1.22.46c-.5.19-1.06-.02-1.37-.49l-1.3-2.25c-.26-.45-.15-1.08.26-1.43l1-.83c.3-.24.44-.61.43-.99v-.25c0-.38-.13-.75-.43-.99l-1-.83c-.41-.35-.52-.98-.26-1.43l1.3-2.25c.31-.47.87-.68 1.37-.49l1.22.45c.35.13.75.07 1.07-.12.07-.05.15-.09.22-.13.33-.18.58-.5.65-.87z"/><circle cx="12" cy="12" r="3"/></g></svg>',
  eye:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M2.6 12A11 11 0 0 1 21.4 12A11 11 0 0 1 2.6 12Z" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="3.1" fill="#fff" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/></svg>',
  eyeOff:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M2.6 12A11 11 0 0 1 21.4 12A11 11 0 0 1 2.6 12Z" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="3.1" fill="#fff" stroke="currentColor" stroke-width="1.7"/><path d="M5 19L19 5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
  remove:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M6.2 6.2l11.6 11.6M17.8 6.2L6.2 17.8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
};

function Markup({ svg, className }) {
  return (
    <span
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}

export default function ManageDrawingsPanel({ open, onClose } = {}) {
  const [items, setItems] = useState([]);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    if (!open) return undefined;
    const refresh = () => setItems(listManagedDrawings());
    refresh();
    const unsubWidget = subscribeChartWidget(() => refresh());
    const unsubDraw = subscribeDrawingsChange(refresh);
    const poll = setInterval(refresh, 1200);
    return () => {
      unsubWidget();
      unsubDraw();
      clearInterval(poll);
    };
  }, [open]);

  if (!open) return null;

  const run = (id, fn) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    fn(id);
    setItems(listManagedDrawings());
  };

  return (
    <aside className="fx-drawings-panel" aria-label="Manage Drawings">
      <header className="fx-drawings-panel__head">
        <h2 className="fx-drawings-panel__title">Manage Drawings</h2>
        <button
          type="button"
          className="fx-drawings-panel__close"
          title="Close"
          aria-label="Close Manage Drawings"
          onClick={onClose}
        >
          <Markup svg={ACTION_ICONS.remove} />
        </button>
      </header>
      <ul className="fx-drawings-panel__list">
        {items.map((item) => (
          <li key={item.id}>
            <div
              className={`fx-drawings-panel__row${activeId === item.id ? " is-active" : ""}${item.hidden ? " is-hidden" : ""}`}
              onClick={() => {
                setActiveId(item.id);
                if (item.selectable) selectManagedDrawing(item.id);
              }}
            >
              <Markup className="fx-drawings-panel__icon" svg={ICONS[item.kind] || ICONS.trend} />
              <span className="fx-drawings-panel__name">{item.name}</span>
              {item.selectable ? (
                <span className="fx-drawings-panel__actions">
                  <button
                    type="button"
                    className={`fx-drawings-panel__action${item.locked ? " is-on" : ""}`}
                    title={item.locked ? "Unlock" : "Lock"}
                    aria-label={item.locked ? "Unlock" : "Lock"}
                    onClick={run(item.id, toggleDrawingLock)}
                  >
                    <Markup svg={item.locked ? ACTION_ICONS.lock : ACTION_ICONS.lockOpen} />
                  </button>
                  <button
                    type="button"
                    className="fx-drawings-panel__action fx-drawings-panel__action--settings"
                    title="Properties"
                    aria-label="Properties"
                    onClick={run(item.id, openDrawingProperties)}
                  >
                    <Markup svg={ACTION_ICONS.settings} />
                  </button>
                  <button
                    type="button"
                    className={`fx-drawings-panel__action${item.hidden ? " is-on" : ""}`}
                    title={item.hidden ? "Show" : "Hide"}
                    aria-label={item.hidden ? "Show" : "Hide"}
                    onClick={run(item.id, toggleDrawingVisible)}
                  >
                    <Markup svg={item.hidden ? ACTION_ICONS.eyeOff : ACTION_ICONS.eye} />
                  </button>
                  <button
                    type="button"
                    className="fx-drawings-panel__action"
                    title="Delete"
                    aria-label="Delete"
                    onClick={run(item.id, (id) => {
                      removeManagedDrawing(id);
                      if (activeId === id) setActiveId(null);
                    })}
                  >
                    <Markup svg={ACTION_ICONS.remove} />
                  </button>
                </span>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
}
